import { batch, signal } from "@preact/signals-react"
import { offices } from "@signals"

export const tableData = signal([])
export const userListFilter = signal(['Enabled'])
export const enabledUsers = signal({})
export const multipleModalIds = signal([])
export const userPayload = signal({})
export const isValidatingUser = signal(false)
export const userErrorRegistry = signal({})
export const editUserId = signal(null)
export const showNewOfficeSection = signal(false)
export const newOfficePayload = signal({})
export const isValidNewOffice = signal({})
export const newCreatedOffice = signal({})
export const multipleUsersModalOption = signal(null)
export const isLoadingApiKey = signal(null)
export const originalUserData = signal(null)
export const showSaveConfirm = signal(false)
export const sitesOptionsMap = signal({})
export const officesOptionsMap = signal({})
export const masterUsersOptionsMap = signal({})
export const featuresOptionsMap = signal({})
export const currencyOptionsMap = signal({})

//functions

export const clearDrawerData = () => batch(() => {
	userPayload.value = {}
	editUserId.value = null
	userErrorRegistry.value = {}
	originalUserData.value = null
	showSaveConfirm.value = false
	sitesOptionsMap.value = {}
	officesOptionsMap.value = {}
	masterUsersOptionsMap.value = {}
	featuresOptionsMap.value = {}
	currencyOptionsMap.value = {}
	showNewOfficeSection.value = false
	newOfficePayload.value = {}
	isValidNewOffice.value = {}
	newCreatedOffice.value = {}
	offices.value = []
})

export const clearNewOffice = () => batch(() => {
	showNewOfficeSection.value = false
	newOfficePayload.value = {}
	isValidNewOffice.value = {}
	newCreatedOffice.value = {}
})

